// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-7c3a870a]{box-sizing:border-box}.timer[data-v-7c3a870a]{font-variant-numeric:tabular-nums}", ""]);
// Exports
module.exports = exports;
